import Vue from 'vue'
import Router from 'vue-router'
// import Tempo from './components/Tempo.vue'
import App from './App.vue'
import Vuex from 'vuex'
import VueSimpleAlert from "vue-simple-alert"
import VueMeta from 'vue-meta'

Vue.config.productionTip = false
Vue.use(Router);
Vue.use(Vuex)
Vue.use(VueSimpleAlert);
Vue.use(require('vue-cookies'))
Vue.$cookies.config('180d')
Vue.use(VueMeta)

var router = new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '*', redirect: '/' },
    { path: '/', component: App },
    { path: '/grid', component: App },
    /* {
      path: '/tempo*', component: App, props: {
        base: 'http://localhost:8080/tempo/oauth/start'
      }
    }, */
  ]
});

new Vue({
  router,
  template: `
    <div>
      <router-view class="view"></router-view>
    </div>
  `
}).$mount('#app')

// new Vue({ el: '#app', router: router, render: h => h(App) })
